import Vue from "vue";
import "amfe-flexible";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css"; // 引入 Element UI 样式
Vue.use(ElementUI);

Vue.config.productionTip = false;

const onImgurl = 'https://kalejoy.com'  //图片线上路径
Vue.prototype.onImgurl = onImgurl

//解决路由跳转滚动置顶问题
router.afterEach(() => {
  window.scrollTo(0, 0);
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
